class ComponentProductFaqV2 extends HTMLElement {
    constructor() {
        super();
        this.iconSvg = faq_v2_icon ?? {};
        this.wrapper = this.querySelectorAll(".wrapper");
        this.questions = this.querySelectorAll('.questions');
        this.answer = this.querySelectorAll('.faq');
        this.init();
    }

    init() {
        let _this = this;
        for (let i = 0; i < _this.questions.length; i++) {
            _this.questions[i].addEventListener("click", function (evt) {
                let icon = evt.currentTarget.querySelector('.icon .icon-inner'),
                    _content = _this.answer[i],
                    isOpen = evt.currentTarget.classList.contains('is-active'),
                    animTitleConf = {
                        targets: icon,
                        rotate: {
                            value: ['.5turn', '1turn'],
                            duration: 300,
                            easing: 'easeInOutSine'
                        },
                        direction: isOpen ? 'normal' : 'reverse',
                        complete: (anim) => {
                            (isOpen) ? icon.innerHTML = _this.iconSvg.plus : icon.innerHTML = _this.iconSvg.minus;
                        }
                    },

                    _contentHeight = anime.get(_content.querySelector('.faq-content-wrapper'), 'height'),

                    animContentConf = {
                        targets: _content,
                        height: [0, _contentHeight],
                        direction: isOpen ? 'reverse' : 'normal',
                        easing: 'easeInOutSine',
                        duration: 300,
                        delay: 100,
                        complete: () => {
                            _content.classList.toggle('active');
                        }
                    };
                // console.log(anime.get(_content, 'height'));
                if (evt.currentTarget.classList.contains('is-active')) {
                    evt.currentTarget.classList.remove('is-active');
                } else {
                    evt.currentTarget.classList.add('is-active');
                }
                anime(animTitleConf);
                anime(animContentConf);
                // evt.currentTarget.classList.toggle('rotate');
            });
        }
    }
}

customElements.define('faq-v2', ComponentProductFaqV2);
